<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-price";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45">
			<path
				d="M18.75 0C9.43125 0 0 2.89875 0 8.4375V15.9375C0 21.4762 9.43125 24.375 18.75 24.375C28.0687 24.375 37.5 21.4762 37.5 15.9375V8.4375C37.5 2.89875 28.0687 0 18.75 0ZM3.75 15.9375V13.6931C4.93759 14.3655 6.19504 14.9062 7.5 15.3056V18.8325C5.04 17.8688 3.75 16.7213 3.75 15.9375ZM26.25 16.215V19.9106C24.6244 20.2462 22.7494 20.4919 20.625 20.5819V16.8319C22.5119 16.7553 24.3913 16.5491 26.25 16.215ZM16.875 20.5838C14.9852 20.5097 13.1042 20.2852 11.25 19.9125V16.2169C13.0481 16.5431 14.9475 16.755 16.875 16.8356V20.5838ZM26.25 19.9106V16.215C30.2779 15.4909 32.5624 14.3655 33.75 13.6931V15.9375C33.75 16.7213 30.6429 19.0037 26.25 19.9106ZM18.75 13.125C9.04312 13.125 3.75 10.0294 3.75 8.4375C3.75 6.84563 9.04312 3.75 18.75 3.75C28.4569 3.75 33.75 6.84563 33.75 8.4375C33.75 10.0294 28.4569 13.125 18.75 13.125Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
